import type { Hex } from 'viem';
import { formatUnits } from 'viem';

/**
 * Use this on the frontend and backend to generate the same message for wallet registration.
 */
export function generateWalletRegistrationMessage(
  address: Hex,
  salt: string
): string {
  // Generate a message that includes the address and salt
  return `Register wallet for address ${address} with token: ${salt}`;
}

/**
 * Formats a token raw amount for display.
 */
export function formatTokenAmountWithOptionalDecimals(
  rawAmount: bigint,
  tokenDecimals: number | null
): string {
  if (tokenDecimals == null) {
    // Case: Formatting is undefined without decimals; fail loudly for callers.
    throw new Error(
      'Cannot format token amount because token decimals are null'
    );
  }
  return formatUnits(rawAmount, tokenDecimals);
}

/** A completed transaction or draft must contain at least one child. */
export type NonEmptyArray<T> = [T, ...T[]];

/** Establish a nonempty collection after a database read, map or eligibility filter. */
export function nonEmptyArray<T>(items: readonly T[]): NonEmptyArray<T> {
  const [first, ...rest] = items;
  if (first === undefined) throw new Error('Expected at least one item');
  return [first, ...rest];
}
